import calendar, { IDayCell } from '../../services/calendar'
import events from '../../services/events'
import customOccasions, { ICustomOccasion } from '../../services/custom-occasions'
import { Draft, EntryKind, draftFromEvent, draftFromOccasion, emptyDraft } from './draft'

export interface EditorSession {
    day: IDayCell & { wd: number }
    draft: Draft
    editing: string
    adopting: string
    original?: ICustomOccasion
    pickDay: boolean
    pickKind: boolean
}

export function loadSession(q: Record<string, string>, defaultKind: EntryKind): EditorSession {
    const t = calendar.today()
    const parts = String(q.d || '').split('-').map(Number)
    const named = parts.length === 3 && parts.every(n => Number.isInteger(n) && n > 0)
    let day = named ? calendar.dayAt(parts[0], parts[1], parts[2], 0) : calendar.dayAt(t.gy, t.gm, t.gd, 0)
    const kind = q.kind === 'occasion' || q.source || (q.id && events.byId(q.id)?.kind === 'occasion')
        ? 'occasion' : defaultKind
    const occasion = kind === 'occasion' && q.id ? customOccasions.byId(q.id) : undefined
    const event = kind === 'event' && q.id ? events.byId(q.id) : undefined
    let draft = emptyDraft(kind)
    if (occasion) {
        draft = draftFromOccasion(occasion)
        // Keep the saved source date, even if moon-sighting data changed since then.
        day = { ...calendar.dayAt(occasion.gy, occasion.gm, occasion.gd, 0),
            jy: occasion.jy, jm: occasion.jm, jd: occasion.jd,
            hy: occasion.hy, hm: occasion.hm, hd: occasion.hd }
    } else if (event) {
        draft = draftFromEvent(event)
        // Editing a later occurrence must not move the series' original start.
        const start = new Date(event.start)
        day = calendar.dayAt(start.getFullYear(), start.getMonth() + 1, start.getDate(), 0)
    } else if (q.title) {
        draft.title = q.title
    }
    return {
        day, draft, editing: occasion?.id || event?.id || '', original: occasion,
        adopting: occasion?.source || q.source || '',
        pickDay: !named && !q.id,
        pickKind: !q.id && !q.source,
    }
}
